export default {
  online_shop: 'Sklep internetowy',
  storefront: 'Witryna sklepowa',
  reservations: 'Rezerwacje',
  import: 'Import',
};
